export default {
	form: {
		returnTypeRequired: "Return type is required",
		targetAttendanceTypeRequired: "Please specify the card type",
	},
	fulfill: "Fulfill",
	fulfilled: "Fulfilled",
	debit: "Debit",
	delete: "Delete",
	deleteConfirmTitle: "Delete return?",
	deleteConfirmText: "This action cannot be undone.",
	messages: {
		createError: "Error creating return",
		created: "Return created successfully",
		debitError: "Error debiting return",
		debited: "Return debited: {remaining}/{total}",
		deleteError: "Error deleting return",
		deleted: "Return deleted",
		fulfillError: "Error fulfilling return",
		fulfilled: "Return fulfilled",
		loadError: "Error loading returns",
	},
	newReturn: "New Return",
	noReturns: "No returns",
	pending: "Pending",
	returnType: {
		COUNTER: "Counter",
		INDEFINITE: "Indefinite",
		RESERVATION: "Reservation",
		NEXT_RITUAL: "Next Ritual",
		SPECIFIC_RITUAL: "Specific Ritual",
		SPECIFIC_DATE: "Specific Date",
	},
	fields: {
		person: "Person",
		type: "Type",
		target: "Target",
		status: "Status",
		notes: "Notes",
	},
	title: "Returns",
};
